import React from 'react';
import {Button, Tooltip} from '@chakra-ui/react';
import { EditIcon } from '@chakra-ui/icons'
import {translateKind} from '../../../src/shared/libs/translate';

export default function TaskTypeIcon({task, ...props}) {
  return (
    <Tooltip label={`Bu alt Görev "${translateKind(task.kind)}" tipinde.`} bg='gray.100' color="black" placement='bottom'>
      <Button leftIcon={<EditIcon />} {...props}>
        { task.kind ? translateKind(task.kind) : 'Tip Belirle' }
      </Button>
    </Tooltip>
  )
}
